import * as stylex from "@stylexjs/stylex";
import { styles } from "./site-footer.styles";
import { externalLinkProps } from "../external-mark";
import type { SiteFooterSocialLink } from "./site-footer-types";

export function SiteFooterSocialLinks({
  socialItems,
}: {
  readonly socialItems: readonly SiteFooterSocialLink[];
}) {
  return (
    <div {...stylex.props(localStyles.social)}>
      <div {...stylex.props(localStyles.socialLinks)}>
        {socialItems.map((social) => (
          <a
            key={social.label}
            href={social.href}
            aria-label={social.label}
            {...(social.href.startsWith("http") ? externalLinkProps : {})}
            {...stylex.props(localStyles.socialLink, styles.linkStates)}
          >
            <img
              alt=""
              src={social.icon}
              {...stylex.props(localStyles.socialIcon)}
            />
          </a>
        ))}
      </div>
    </div>
  );
}

const localStyles = stylex.create({
  social: { position: "relative", height: 24, width: 200, flexShrink: 0 },
  socialLinks: {
    position: "absolute",
    top: 0,
    right: 0,
    left: { default: 0, "@media (min-width: 768px)": "auto" },
    display: "flex",
    alignItems: "center",
    justifyContent: {
      default: "center",
      "@media (min-width: 768px)": "flex-end",
    },
    gap: { default: 10, "@media (pointer: coarse)": 20 },
  },
  socialLink: {
    position: "relative",
    display: "block",
    width: 24,
    height: 24,
    flexShrink: 0,
    "::after": {
      content: { default: "none", "@media (pointer: coarse)": '""' },
      position: "absolute",
      inset: -10,
    },
  },
  socialIcon: {
    position: "absolute",
    inset: 0,
    display: "block",
    width: "100%",
    height: "100%",
    maxWidth: "none",
  },
});
